import { Platform } from '@/shared/enums';

export default {
  namespaced: true,
  state: {
    name: Platform.BROWSER,
  },
  mutations: {
    SET_EMBEDDED_PLAYER(state) {
      state.name = Platform.EMBEDDED_PLAYER;
    },
  },
};
